/* eslint-disable @angular-eslint/directive-class-suffix */
/* eslint-disable @angular-eslint/no-host-metadata-property */
/* eslint-disable @typescript-eslint/no-explicit-any */

import { Directive } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessor } from './value.accessor';

const SELECT_VALUE_SELECTOR_LIST = `
  dcr-select[formControl]:not([multiple]):not([valueAsNumber]),
  dcr-select[formControlName]:not([multiple]):not([valueAsNumber]),
  dcr-select[ngModel]:not([multiple]):not([valueAsNumber]),
  dcr-filter-chip[formControl]:not([multiple]):not([toggle]):not([valueAsNumber]),
  dcr-filter-chip[formControlName]:not([multiple]):not([toggle]):not([valueAsNumber]),
  dcr-filter-chip[ngModel]:not([multiple]):not([toggle]):not([valueAsNumber]),
`;

@Directive({
    selector: SELECT_VALUE_SELECTOR_LIST,
    host: {
        '(change)': 'handleChangeEvent($event.target.value)',
        '(input)': 'handleChangeEvent($event.target.value)',
        '(closed)': 'handleBlurEvent()', //not blur or focusout, because proxy fires blur on each select
    },
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: SelectValueAccessor,
            multi: true,
        },
    ],
    standalone: false
})
export class SelectValueAccessor extends ValueAccessor {}
